import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { DemoBackdrop, glow } from "./shared";
import { RainbowEAKC } from "../shared/RainbowEAKC";

export const Scene08Outro: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const titleSp = spring({ frame, fps, config: SPRING.bouncy });
  const titleOp = interpolate(titleSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const titleScale = interpolate(titleSp, [0, 1], [0.4, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const urlSp = spring({ frame: frame - 40, fps, config: SPRING.gentle });
  const urlOp = interpolate(urlSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const ctaSp = spring({ frame: frame - 80, fps, config: SPRING.gentle });
  const ctaOp = interpolate(ctaSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const pulse = interpolate(Math.sin(frame * 0.08), [-1, 1], [15, 40]);

  return (
    <AbsoluteFill style={{ background: COLORS.bg, overflow: "hidden" }}>
      <DemoBackdrop frame={frame} accent={COLORS.neonPurple} />

      <div style={{
        position: "absolute", inset: 0,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        gap: 30,
      }}>
        <RainbowEAKC
          id="pd-outro"
          frame={frame}
          fontSize={220}
          fontFamily={FONTS.heading}
          scale={titleScale}
          opacity={titleOp}
          glowColor={COLORS.neonPurple}
        />
        <div style={{
          fontSize: 44,
          fontFamily: FONTS.heading,
          fontWeight: 700,
          color: COLORS.neonCyan,
          textShadow: glow(COLORS.neonCyan, true),
          opacity: urlOp,
          letterSpacing: 3,
        }}>
          Your Company's Brain
        </div>
        <div style={{
          fontSize: 30,
          fontFamily: FONTS.mono,
          color: COLORS.neonCyan,
          opacity: urlOp,
          padding: "16px 32px",
          border: `2px solid ${COLORS.neonCyan}77`,
          borderRadius: 50,
          background: `${COLORS.neonCyan}08`,
          textShadow: `0 0 ${pulse}px ${COLORS.neonCyan}cc`,
          marginTop: 20,
        }}>
          eakc.adaptivesmartsystems.cc
        </div>
        <div style={{
          fontSize: 22,
          fontFamily: FONTS.body,
          color: COLORS.textMuted,
          marginTop: 18,
          opacity: ctaOp,
          letterSpacing: 1,
        }}>
          Self-host it today · Try the demo · Talk to us
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
